'use strict';

/*globals isEmpty*/
/*globals Handsontable*/

function K2Handsontable($container, setting) {
  this.$container = $container;

  this.defaultSetting = {};
  this.setting = setting;
  this.handsontable = null;

  this.errors = [];

  this.init();
}

K2Handsontable.prototype = $.extend({}, {
  construtor: 'K2Handsontable',

  //**************************************************************************

  isEmptyRowData: function isEmptyRowData(rowData) {
    var empty = true;
    $.each(rowData, function (key, value) {
      if (!isEmpty(value)) {
        empty = false;
        return false;
      }
    });

    return empty;
  },

  getData: function getData() {
    var _this = this;

    var data = [];
    $.each(_this.handsontable.getData(), function (rowIndex, row) {
      var rowData = {};
      $.each(row, function (colIndex, col) {
        rowData[_this.setting.columns[colIndex].data] = col;
      });

      if (!_this.isEmptyRowData(rowData)) {
        data.push(rowData);
      }
    });

    return data;
  },

  setErrors: function setErrors(errors) {
    var _this = this;

    _this.errors = errors;

    _this.handsontable.setDataAtCell(0, 0, _this.handsontable.getDataAtCell(0, 0));

    return _this;
  },

  destroy: function destroy() {
    var _this = this;

    _this.handsontable.destroy();
  },

  //**************************************************************************

  initDefualtSetting: function initDefualtSetting() {
    var _this = this;

    _this.defaultSetting = {
      //data: dataObject,
      //columns: [],
      //colHeaders: [],

      stretchH: 'all',
      colHeaders: true,
      rowHeaders: true,
      contextMenu: true,
      filters: true,
      dropdownMenu: true,
      minSpareRows: 6,
      autoWrapRow: false,
      autoWrapCol: false,
      cells: function (/*row, col*/) {
        var cellProperties = {};

        cellProperties.renderer = function (instance, td, row, col/*, prop, value, cellProperties*/) {
          Handsontable.renderers.TextRenderer.apply(this, arguments);

          if (_this.setting.columns[col]) {
            col = _this.setting.columns[col].data;
            if ((row in _this.errors) && (col in _this.errors[row]) && _this.errors[row][col]) {
              td.style.background = '#F9C1C1';
            }
          }
        };

        return cellProperties;
      }
    };

    return _this;
  },

  initHandsontable: function initHandsontable() {
    var _this = this;

    _this.handsontable = new Handsontable(_this.$container.get(0),
    _this.setting = $.extend({}, _this.defaultSetting, _this.setting));

    return _this;
  },

  //**************************************************************************

  init: function init() {
    var _this = this;

    _this.initDefualtSetting();
    _this.initHandsontable();

    return _this;
  }
});
